import { PromptPage } from './PromptPage/PromptPage';

export default PromptPage;
